module.exports = __webpack_public_path__ + "img/产品加工图标.5e0681e7.svg";